import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { environment } from './environments/environment';

registerLocaleData(localePtBr, 'pt-BR');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

if (environment.production) {
    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};
    window.console.info = () => {};
    window.console.debug = () => {};
    window.console.warn = () => {};
    window.console.log = () => {};
}
